export const formatCurrency = (value: number): string => {
  // Divide the value by 100 and convert it to a fixed-point string with 2 decimals
  return (value / 100).toFixed(2)
}